const state = {
  tooltips: [],
  tooltipIndex: -1,
};

const mutations = {
  setTooltips(state, { tooltips = [] }) { state.tooltips = tooltips; },
  setTooltipIndex(state, { tooltipIndex = -1 }) { state.tooltipIndex = tooltipIndex; },
};

const actions = {
  setTooltips({ commit }, { tooltips = [] }) {
    commit('setTooltips', { tooltips });
    commit('setTooltipIndex', { tooltipIndex: -1 });
  },
  addTooltips({ commit, getters }, { tooltips = [] }) {
    commit('setTooltips', { tooltips: getters.tooltips.concat(tooltips) });
  },
  async advanceTooltip({ commit, getters: { tooltipIndex = -1, tooltips = [] } }) {
    const previousTooltip = (tooltipIndex < 0 || tooltipIndex >= tooltips.length) ? undefined : tooltips[tooltipIndex];
    const newNI = tooltipIndex + 1;
    const nextTooltip = (newNI < 0 || newNI >= tooltips.length) ? undefined : tooltips[newNI];
    if (newNI >= tooltips.length) {
      commit('setTooltips', { tooltips: [] });
      commit('setTooltipIndex', { tooltipIndex: -1 });
    } else if (nextTooltip && previousTooltip && (nextTooltip.target === previousTooltip.target)) {
      commit('setTooltipIndex', { tooltipIndex: -1 });
      await new Promise(resolve => setTimeout(resolve, 1));
      commit('setTooltipIndex', { tooltipIndex: newNI });
    } else {
      commit('setTooltipIndex', { tooltipIndex: newNI });
    }
  },
  /**
   * sets the tooltip progress state to the first tooltip with the given target, if it exists, otherwise does nothing.
   * tooltips is passed in to account for the case where you've gone past the end, which sets state.tooltips to [].
   */
  async rewindToTooltipTarget({ commit, state }, { target = '', tooltips = [] }) {
    const tooltipIndex = state.tooltipIndex;
    // console.log(tooltipIndex);
    // console.log(state.tooltips);
    // console.log(tooltips);
    const newNI = tooltips.findIndex(tooltip => tooltip.target === target);
    // console.log(newNI);
    if (newNI >= 0) {
      if (tooltips.length && (tooltips.length !== state.tooltips.length)) {
        commit('setTooltips', { tooltips });
        // console.log(state.tooltips);
      }
      const currentTooltip = (tooltipIndex < 0 || tooltipIndex >= state.tooltips.length) ? undefined : state.tooltips[tooltipIndex];
      if (newNI < state.tooltips.length) {
        if (tooltipIndex !== newNI && currentTooltip && (target === currentTooltip.target)) {
          commit('setTooltipIndex', { tooltipIndex: -1 });
          await new Promise(resolve => setTimeout(resolve, 1));
          commit('setTooltipIndex', { tooltipIndex: newNI });
        } else {
          commit('setTooltipIndex', { tooltipIndex: newNI });
        }
      }
    }
  },
};

const getters = {
  tooltips({ tooltips }) { return tooltips; },
  tooltipIndex({ tooltipIndex = -1 }) { return tooltipIndex; },
  lastTooltip({ tooltips = [], tooltipIndex = -1 }) {
    const lastIndex = tooltipIndex - 1;
    return (lastIndex < 0 || lastIndex >= tooltips.length) ? undefined : tooltips[lastIndex];
  },
  tooltip({ tooltips = [], tooltipIndex = -1 }) {
    return (tooltipIndex < 0 || tooltipIndex >= tooltips.length) ? undefined : tooltips[tooltipIndex];
  },
  nextTooltip({ tooltips = [], tooltipIndex = -1 }) {
    const nextIndex = tooltipIndex + 1;
    return (nextIndex < 0 || nextIndex >= tooltips.length) ? undefined : tooltips[nextIndex];
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/game/tooltip.js